import { T } from "@repo/transifex";
import { type UserCollectLimit, type Currency } from "~/api/products/types";
import { priceFormatter } from "~/utils/price-formatter";

import { BasketHeaderText } from "../basket-header-text";

export type HeaderCollectLimitProps = {
  collectLimit: UserCollectLimit | null;
  currency: Currency;
  locale: string;
};

export const HeaderCollectLimit = ({
  collectLimit,
  currency,
  locale
}: HeaderCollectLimitProps) => {
  if (!collectLimit) {
    return null;
  }

  return (
    <div className="inline-flex gap-1">
      <BasketHeaderText>
        <T _str="Available Today" />
      </BasketHeaderText>

      <div className="inline-flex gap-1">
        <BasketHeaderText
          variant={
            collectLimit.unitAvailableInclVat > 0 ? "positive" : "negative"
          }
        >
          {priceFormatter({
            value: collectLimit.unitAvailableInclVat,
            currency,
            locale
          })}
        </BasketHeaderText>

        <BasketHeaderText>/</BasketHeaderText>

        <BasketHeaderText variant="positive">
          {priceFormatter({
            value: collectLimit.unitLimitInclVat,
            currency,
            locale
          })}
        </BasketHeaderText>
      </div>
    </div>
  );
};
